(function () {
  try {
    document.documentElement.classList.add('js');
  } catch (e) {}

  function prefersReducedMotion() {
    try {
      return (
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
      );
    } catch (e) {
      return false;
    }
  }

  function scrollBehavior() {
    return prefersReducedMotion() ? 'auto' : 'smooth';
  }

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
      return;
    }
    callback();
  }

  function parseJsonBoolean(value, fallback) {
    if (value === undefined || value === null || value === '') return fallback;
    if (value === true || value === false) return value;
    try {
      return !!JSON.parse(value);
    } catch (e) {
      return fallback;
    }
  }

  var pageScrollLockDepth = 0;

  function setPageScrollLocked(locked) {
    if (!document.body) return;

    if (locked) {
      pageScrollLockDepth += 1;
    } else {
      pageScrollLockDepth = Math.max(0, pageScrollLockDepth - 1);
    }

    var shouldLock = pageScrollLockDepth > 0;
    document.documentElement.classList.toggle('modal-open', shouldLock);
    document.body.classList.toggle('modal-open', shouldLock);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision === undefined ? 2 : precision;
    thousands = thousands || ',';
    decimal = decimal || '.';

    if (number === null || number === undefined) return '0';

    var num = Number(number);
    if (!Number.isFinite(num)) return '0';

    var fixed = (num / 100).toFixed(precision);
    var parts = fixed.split('.');
    var dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    var cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }

  function formatMoney(cents, format) {
    var moneyFormat =
      (window.Deliciosso && window.Deliciosso.moneyFormat) || '${{amount}}';
    var formatString = format || moneyFormat || '${{amount}}';
    var value = cents;
    if (typeof value === 'string') value = value.replace('.', '');
    if (!Number.isFinite(Number(value))) value = 0;

    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = formatString.match(placeholderRegex);
    var formatToken = match && match[1] ? match[1] : 'amount';

    var formatted = '';
    switch (formatToken) {
      case 'amount_no_decimals':
        formatted = formatWithDelimiters(value, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        formatted = formatWithDelimiters(value, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        formatted = formatWithDelimiters(value, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        formatted = formatWithDelimiters(value, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        formatted = formatWithDelimiters(value, 0, ' ', '.');
        break;
      case 'amount_with_apostrophe_separator':
        formatted = formatWithDelimiters(value, 2, "'", '.');
        break;
      default:
        formatted = formatWithDelimiters(value, 2, ',', '.');
        break;
    }

    return formatString.replace(placeholderRegex, formatted);
  }

  function updateCartCount(cart) {
    if (!cart) return;
    var counts = document.querySelectorAll('[data-cart-count]');
    var nextCount = Number(cart.item_count || 0);
    var prevCount = Number(window.Deliciosso.cartCount || 0);
    var shouldPop = nextCount > prevCount;
    Array.prototype.forEach.call(counts, function (el) {
      if (!el) return;
      el.textContent = String(cart.item_count || 0);
      el.classList.toggle('is-empty', nextCount === 0);
      if (shouldPop) {
        el.classList.remove('cart-count-pop');
        void el.offsetWidth;
        el.classList.add('cart-count-pop');
      }
    });
    window.Deliciosso.cartCount = nextCount;
  }

  function fetchCart() {
    return fetch('/cart.js', {
      headers: {
        Accept: 'application/json'
      }
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart fetch failed');
      return response.json();
    });
  }

  function initCartCount(root) {
    var scope = root && root.querySelector ? root : document;
    var counts = scope.querySelectorAll('[data-cart-count]');
    if (!counts || !counts.length) return;
    var guard =
      (scope.dataset && scope.dataset.cartCountInit === 'true') ||
      document.body.dataset.cartCountInit === 'true';
    if (guard) return;
    document.body.dataset.cartCountInit = 'true';

    fetchCart()
      .then(function (cart) {
        updateCartCount(cart);
      })
      .catch(function () {});
  }

  function initCartModal(root) {
    var scope = root && root.querySelector ? root : document;
    var modal = document.querySelector('[data-cart-modal]');
    if (!modal || modal.dataset.initialized === 'true') return;
    modal.dataset.initialized = 'true';

    var itemsWrap = modal.querySelector('[data-cart-modal-items]');
    var subtotalEl = modal.querySelector('[data-cart-modal-subtotal]');
    var statusEl = modal.querySelector('[data-cart-modal-status]');
    var emptyEl = modal.querySelector('[data-cart-modal-empty]');
    var checkoutBtn = modal.querySelector('[data-cart-modal-checkout]');
    var closeButtons = modal.querySelectorAll('[data-cart-modal-close]');
    var focusableSelector =
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';

    var lastFocused = null;
    var isOpen = false;
    var busy = false;

    // Some storefront contexts render checkout_url as blank. Keep the CTA
    // deterministic so cart -> checkout never dead-ends.
    if (checkoutBtn) {
      var checkoutHref = checkoutBtn.getAttribute('href');
      if (!checkoutHref) checkoutBtn.setAttribute('href', '/checkout');
    }

    function setStatus(message) {
      if (!statusEl) return;
      if (!message) {
        statusEl.textContent = '';
        statusEl.setAttribute('hidden', '');
        return;
      }
      statusEl.textContent = message;
      statusEl.removeAttribute('hidden');
    }

    function setBusy(nextBusy) {
      busy = !!nextBusy;
      modal.classList.toggle('is-busy', busy);
    }

    var trashIcon = modal.dataset.trashIcon || '';

    function renderItems(cart) {
      if (!itemsWrap) return;
      itemsWrap.innerHTML = '';

      if (!cart || !cart.items || cart.items.length === 0) {
        if (emptyEl) emptyEl.removeAttribute('hidden');
        if (checkoutBtn) checkoutBtn.setAttribute('hidden', '');
        return;
      }

      if (emptyEl) emptyEl.setAttribute('hidden', '');
      if (checkoutBtn) checkoutBtn.removeAttribute('hidden');

      cart.items.forEach(function (item) {
        var itemEl = document.createElement('article');
        itemEl.className = 'cart-item cart-item--modal';
        itemEl.dataset.cartItemKey = item.key;

        var media = document.createElement('div');
        media.className = 'cart-item__media';
        if (item.image) {
          var link = document.createElement('a');
          link.href = item.url || '#';
          var img = document.createElement('img');
          img.src = item.image;
          img.alt = item.product_title || item.title || 'Producto';
          img.loading = 'lazy';
          link.appendChild(img);
          media.appendChild(link);
        }

        var body = document.createElement('div');
        body.className = 'cart-item__body';

        var top = document.createElement('div');
        top.className = 'cart-item__top';

        var heading = document.createElement('div');

        var eyebrow = document.createElement('p');
        eyebrow.className = 'cart-item__eyebrow';
        eyebrow.textContent = item.product_type || 'Producto';

        var title = document.createElement('h3');
        title.className = 'cart-item__title';

        var titleLink = document.createElement('a');
        titleLink.href = item.url || '#';
        titleLink.textContent = item.product_title || item.title || 'Producto';
        title.appendChild(titleLink);

        var variant = document.createElement('p');
        variant.className = 'cart-item__variant';
        var hasVariant =
          item.variant_title && item.variant_title !== 'Default Title';
        variant.textContent = hasVariant ? item.variant_title : '';

        heading.appendChild(eyebrow);
        heading.appendChild(title);
        if (hasVariant) heading.appendChild(variant);

        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'cart-item__remove cart-item__remove--icon';
        remove.setAttribute('data-cart-remove', '');
        remove.setAttribute('data-cart-item-key', item.key);
        remove.setAttribute(
          'aria-label',
          'Eliminar ' + (item.product_title || item.title || 'producto')
        );
        if (trashIcon) {
          var removeIcon = document.createElement('img');
          removeIcon.src = trashIcon;
          removeIcon.alt = '';
          removeIcon.setAttribute('aria-hidden', 'true');
          remove.appendChild(removeIcon);
        }
        var removeText = document.createElement('span');
        removeText.className = 'visually-hidden';
        removeText.textContent = 'Eliminar';
        remove.appendChild(removeText);

        top.appendChild(heading);
        top.appendChild(remove);

        var properties = document.createElement('ul');
        properties.className = 'cart-item__properties';

        if (item.properties) {
          Object.keys(item.properties).forEach(function (key) {
            if (!key || key.charAt(0) === '_') return;
            var raw = item.properties[key];
            if (raw === null || raw === undefined || raw === '') return;
            var value = Array.isArray(raw) ? raw.join(', ') : String(raw);
            var label = key;
            var lower = key.toLowerCase();
            if (lower.indexOf('molienda') !== -1) label = 'Molienda';
            if (lower.indexOf('gramaje') !== -1 || lower.indexOf('peso') !== -1) {
              label = 'Gramaje';
            }
            var propItem = document.createElement('li');
            propItem.innerHTML =
              '<strong>' + label + ':</strong> ' + value;
            properties.appendChild(propItem);
          });
        }

        var meta = document.createElement('div');
        meta.className = 'cart-item__meta';

        var priceStack = document.createElement('div');
        priceStack.className = 'price-stack';

        if (
          item.original_line_price &&
          item.original_line_price !== item.final_line_price
        ) {
          var priceCompare = document.createElement('span');
          priceCompare.className = 'price-compare';
          priceCompare.textContent = formatMoney(item.original_line_price);
          priceStack.appendChild(priceCompare);
        }

        var priceCurrent = document.createElement('span');
        priceCurrent.className = 'price-current';
        priceCurrent.textContent = formatMoney(item.final_line_price || 0);
        priceStack.appendChild(priceCurrent);

        var qtyField = document.createElement('div');
        qtyField.className = 'qty-field';

        var qtyLabel = document.createElement('span');
        qtyLabel.textContent = 'Cantidad';

        var qtyControl = document.createElement('div');
        qtyControl.className = 'qty-control';

        var minus = document.createElement('button');
        minus.type = 'button';
        minus.className = 'qty-control__btn';
        minus.textContent = '-';
        minus.setAttribute('data-cart-qty-minus', '');
        minus.setAttribute('aria-label', 'Disminuir cantidad');

        var input = document.createElement('input');
        input.type = 'number';
        input.min = '0';
        input.value = String(item.quantity || 0);
        input.setAttribute('data-cart-qty-input', '');
        input.setAttribute('data-cart-item-key', item.key);
        input.setAttribute(
          'aria-label',
          'Cantidad para ' + (item.product_title || 'producto')
        );

        var plus = document.createElement('button');
        plus.type = 'button';
        plus.className = 'qty-control__btn';
        plus.textContent = '+';
        plus.setAttribute('data-cart-qty-plus', '');
        plus.setAttribute('aria-label', 'Aumentar cantidad');

        qtyControl.appendChild(minus);
        qtyControl.appendChild(input);
        qtyControl.appendChild(plus);

        qtyField.appendChild(qtyLabel);
        qtyField.appendChild(qtyControl);

        meta.appendChild(priceStack);
        meta.appendChild(qtyField);

        body.appendChild(top);
        if (properties.children.length) body.appendChild(properties);
        body.appendChild(meta);

        itemEl.appendChild(media);
        itemEl.appendChild(body);
        itemsWrap.appendChild(itemEl);
      });
    }

    function updateSummary(cart) {
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price || 0);
      updateCartCount(cart);
    }

    function refreshCart() {
      setBusy(true);
      return fetchCart()
        .then(function (cart) {
          renderItems(cart);
          updateSummary(cart);
          setStatus('');
          return cart;
        })
        .catch(function () {
          setStatus('No se pudo cargar el carrito.');
        })
        .finally(function () {
          setBusy(false);
        });
    }

    function openModal(trigger) {
      if (isOpen) return;
      isOpen = true;
      lastFocused = trigger || document.activeElement;
      modal.classList.add('is-open');
      setPageScrollLocked(true);
      refreshCart();

      var focusTarget = modal.querySelector('[data-cart-modal-close]') || modal;
      window.setTimeout(function () {
        try {
          focusTarget.focus();
        } catch (e) {}
      }, 0);
    }

    function closeModal() {
      if (!isOpen) return;
      isOpen = false;
      modal.classList.remove('is-open');
      setPageScrollLocked(false);
      if (lastFocused && typeof lastFocused.focus === 'function') {
        try {
          lastFocused.focus();
        } catch (e) {}
      }
    }

    function trapFocus(event) {
      if (!isOpen || event.key !== 'Tab') return;
      var focusables = modal.querySelectorAll(focusableSelector);
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    document.addEventListener('keydown', function (event) {
      if (!isOpen) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal();
      } else {
        trapFocus(event);
      }
    });

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-cart-modal-open]');
      if (opener) {
        event.preventDefault();
        openModal(opener);
      }
    });

    Array.prototype.forEach.call(closeButtons, function (btn) {
      btn.addEventListener('click', function () {
        closeModal();
      });
    });

    window.addEventListener('pagehide', closeModal);
    window.addEventListener('pageshow', closeModal);

    if (itemsWrap) {
      itemsWrap.addEventListener('click', function (event) {
        var minus = event.target.closest('[data-cart-qty-minus]');
        var plus = event.target.closest('[data-cart-qty-plus]');
        var remove = event.target.closest('[data-cart-remove]');
        var input = event.target.closest('[data-cart-qty-input]');
        var itemEl = event.target.closest('.cart-item--modal');
        var key =
          (remove && remove.getAttribute('data-cart-item-key')) ||
          (input && input.getAttribute('data-cart-item-key')) ||
          (itemEl && itemEl.getAttribute('data-cart-item-key'));
        if (!key || busy) return;

        if (remove) {
          setStatus('Actualizando carrito…');
          setBusy(true);
          fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ id: key, quantity: 0 })
          })
            .then(function () {
              return refreshCart();
            })
            .finally(function () {
              setBusy(false);
            });
          return;
        }

        if (minus || plus) {
          if (!itemEl) return;
          var inputEl = itemEl.querySelector('[data-cart-qty-input]');
          if (!inputEl) return;
          var current = parseInt(inputEl.value || '0', 10);
          if (!Number.isFinite(current)) current = 0;
          var nextQty = minus ? Math.max(0, current - 1) : current + 1;
          inputEl.value = String(nextQty);
          setStatus('Actualizando carrito…');
          setBusy(true);
          fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ id: key, quantity: nextQty })
          })
            .then(function () {
              return refreshCart();
            })
            .finally(function () {
              setBusy(false);
            });
          return;
        }

        if (input && event.target.matches('[data-cart-qty-input]')) {
          return;
        }
      });
    }

    if (itemsWrap) {
      itemsWrap.addEventListener('change', function (event) {
        var input = event.target.closest('[data-cart-qty-input]');
        if (!input || busy) return;
        var key = input.getAttribute('data-cart-item-key');
        if (!key) return;
        var nextVal = parseInt(input.value || '0', 10);
        if (!Number.isFinite(nextVal) || nextVal < 0) nextVal = 0;
        input.value = String(nextVal);
        setStatus('Actualizando carrito…');
        setBusy(true);
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ id: key, quantity: nextVal })
        })
          .then(function () {
            return refreshCart();
          })
          .finally(function () {
            setBusy(false);
          });
      });
    }

    function bindAddToCartForm(form) {
      if (!form || form.dataset.cartModalInit === 'true') return;
      form.dataset.cartModalInit = 'true';
      form.addEventListener('submit', function (event) {
        var submitter = event.submitter;
        if (submitter && submitter.classList.contains('shopify-payment-button__button')) {
          return;
        }
        if (submitter && submitter.name && submitter.name !== 'add') {
          return;
        }

        event.preventDefault();
        var addButton =
          submitter ||
          form.querySelector('button[name="add"]') ||
          form.querySelector('#AddToCart');
        if (addButton) addButton.disabled = true;
        var loadingTimer = null;
        if (addButton) {
          loadingTimer = window.setTimeout(function () {
            addButton.classList.add('is-loading');
          }, 250);
        }
        setStatus('Agregando al carrito…');
        setBusy(true);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json'
          },
          body: new FormData(form)
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Add to cart failed');
            return response.json();
          })
          .then(function () {
            openModal(addButton);
          })
          .catch(function () {
            setStatus('No se pudo agregar el producto.');
          })
          .finally(function () {
            if (loadingTimer) window.clearTimeout(loadingTimer);
            setBusy(false);
            if (addButton) {
              addButton.disabled = false;
              addButton.classList.remove('is-loading');
            }
          });
      });
    }

    var productForm = document.getElementById('AddToCartForm');
    bindAddToCartForm(productForm);

    var cardForms = scope.querySelectorAll('form.card-atc');
    Array.prototype.forEach.call(cardForms, function (form) {
      bindAddToCartForm(form);
    });
  }

  function initCollectionCardLinks(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var cards = scope.querySelectorAll('[data-card-url]');
    if (!cards || !cards.length) return;

    Array.prototype.forEach.call(cards, function (card) {
      if (!card || card.dataset.cardInit === 'true') return;
      card.dataset.cardInit = 'true';

      card.addEventListener('click', function (event) {
        var target = event.target;
        if (!target) return;

        if (
          target.closest &&
          (target.closest('a') ||
            target.closest('button') ||
            target.closest('form') ||
            target.closest('input') ||
            target.closest('select') ||
            target.closest('textarea'))
        ) {
          return;
        }

        var url = card.getAttribute('data-card-url');
        if (!url) return;
        window.location.href = url;
      });
    });
  }

  function initProductGalleries(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var galleries = scope.querySelectorAll('[data-product-gallery]');
    if (!galleries || !galleries.length) return;

    Array.prototype.forEach.call(galleries, function (gallery) {
      if (!gallery || gallery.dataset.initialized === 'true') return;
      gallery.dataset.initialized = 'true';

      var stage = gallery.querySelector('[data-product-gallery-stage]') || gallery;
      var mainImage = gallery.querySelector('[data-product-gallery-main]');
      var counter = gallery.querySelector('[data-product-gallery-counter]');
      if (!mainImage) return;

      var thumbs = Array.prototype.slice.call(
        gallery.querySelectorAll('[data-product-gallery-thumb]')
      );
      if (!thumbs.length) {
        if (counter) counter.setAttribute('hidden', '');
        return;
      }

      function updateCounter(activeIndex) {
        if (!counter) return;
        if (thumbs.length <= 1) {
          counter.setAttribute('hidden', '');
          return;
        }
        counter.textContent = String(activeIndex + 1) + ' / ' + String(thumbs.length);
        counter.removeAttribute('hidden');
      }

      function setActiveThumb(activeThumb) {
        var activeIndex = 0;
        thumbs.forEach(function (thumb, index) {
          var isActive = thumb === activeThumb;
          thumb.classList.toggle('is-active', isActive);
          if (isActive) {
            activeIndex = index;
            thumb.setAttribute('aria-current', 'true');
          } else {
            thumb.removeAttribute('aria-current');
          }
        });
        updateCounter(activeIndex);
      }

      function activateThumb(thumb) {
        var nextSrc = thumb.getAttribute('data-image-src');
        var nextSrcset = thumb.getAttribute('data-image-srcset');
        var nextSizes = thumb.getAttribute('data-image-sizes');
        var nextAlt = thumb.getAttribute('data-image-alt') || '';
        if (!nextSrc) return;

        if (nextSrcset) {
          mainImage.setAttribute('srcset', nextSrcset);
        } else {
          mainImage.removeAttribute('srcset');
        }

        if (nextSizes) {
          mainImage.setAttribute('sizes', nextSizes);
        } else {
          mainImage.removeAttribute('sizes');
        }

        if (mainImage.getAttribute('src') !== nextSrc) {
          mainImage.setAttribute('src', nextSrc);
        }
        mainImage.setAttribute('alt', nextAlt);
        setActiveThumb(thumb);
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          activateThumb(thumb);
        });
      });

      var initialThumb =
        thumbs.find(function (thumb) {
          return (
            thumb.getAttribute('aria-current') === 'true' ||
            thumb.classList.contains('is-active')
          );
        }) || thumbs[0];
      setActiveThumb(initialThumb);

      var touchStartX = 0;
      var touchStartY = 0;

      stage.addEventListener(
        'touchstart',
        function (event) {
          var touch = event.touches && event.touches[0];
          if (!touch) return;
          touchStartX = touch.clientX;
          touchStartY = touch.clientY;
        },
        { passive: true }
      );

      stage.addEventListener(
        'touchend',
        function (event) {
          var touch = event.changedTouches && event.changedTouches[0];
          if (!touch) return;

          var deltaX = touch.clientX - touchStartX;
          var deltaY = touch.clientY - touchStartY;

          if (Math.abs(deltaX) < 45) return;
          if (Math.abs(deltaX) < Math.abs(deltaY) * 1.2) return;

          var activeIndex = thumbs.findIndex(function (thumb) {
            return (
              thumb.getAttribute('aria-current') === 'true' ||
              thumb.classList.contains('is-active')
            );
          });
          if (activeIndex < 0) activeIndex = 0;

          var nextIndex = deltaX < 0 ? activeIndex + 1 : activeIndex - 1;
          if (nextIndex < 0) nextIndex = 0;
          if (nextIndex > thumbs.length - 1) nextIndex = thumbs.length - 1;
          if (nextIndex === activeIndex) return;

          activateThumb(thumbs[nextIndex]);
        },
        { passive: true }
      );
    });
  }

  function initPdpStickyAtc() {
    var sticky = document.querySelector('[data-pdp-sticky-atc]');
    if (!sticky || sticky.dataset.initialized === 'true') return;
    sticky.dataset.initialized = 'true';

    var form = document.getElementById('AddToCartForm');
    var addToCartButton = document.getElementById('AddToCart');
    var buyNowButton = document.getElementById('BuyNow');
    var select = document.getElementById('productSelect');
    var quantity = document.getElementById('Quantity');
    var paymentWrap = form ? form.querySelector('[data-shopify-payment-button-wrap]') : null;
    var variantFeedback = form ? form.querySelector('[data-variant-feedback]') : null;

    var stickyButton = sticky.querySelector('[data-pdp-sticky-button]');
    var stickyPrice = sticky.querySelector('[data-pdp-sticky-price]');
    var stickyVariant = sticky.querySelector('[data-pdp-sticky-variant]');

    if (!form || !addToCartButton || !stickyButton) return;

    var availabilitySource =
      form.getAttribute('data-product-available') ||
      (document.querySelector('[data-product-available]') &&
        document.querySelector('[data-product-available]').getAttribute('data-product-available'));

    var productAvailable = parseJsonBoolean(availabilitySource, true);

    var isCoarsePointer = false;
    try {
      isCoarsePointer =
        window.matchMedia &&
        window.matchMedia('(hover: none) and (pointer: coarse)').matches;
    } catch (e) {}

    var isMobileLayout = false;
    try {
      isMobileLayout = window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
    } catch (e) {}

    var shouldBlurTap = isCoarsePointer || isMobileLayout;

    function blurOnTap(element) {
      if (!shouldBlurTap || !element) return;
      var handler = function () {
        window.setTimeout(function () {
          try {
            element.blur();
          } catch (e) {}
        }, 0);
      };
      element.addEventListener('pointerup', handler, { capture: true });
      element.addEventListener('touchend', handler, { capture: true, passive: true });
      element.addEventListener('mouseup', handler, { capture: true });
    }

    blurOnTap(addToCartButton);
    blurOnTap(buyNowButton);
    blurOnTap(stickyButton);

    if (shouldBlurTap) {
      form.addEventListener(
        'submit',
        function () {
          var active = document.activeElement;
          if (active && typeof active.blur === 'function') {
            window.setTimeout(function () {
              try {
                active.blur();
              } catch (e) {}
            }, 0);
          }
        },
        true
      );
    }

    function setStickyHidden(hidden) {
      if (hidden) {
        sticky.setAttribute('hidden', '');
        document.body.classList.remove('has-pdp-sticky-atc');
      } else {
        sticky.removeAttribute('hidden');
        document.body.classList.add('has-pdp-sticky-atc');
      }
    }

    function getSelectedOption(selectEl) {
      if (!selectEl) return null;
      return selectEl.options[selectEl.selectedIndex] || null;
    }

    function setPurchaseState(canPurchase) {
      addToCartButton.disabled = !canPurchase;
      if (buyNowButton) buyNowButton.disabled = !canPurchase;
      addToCartButton.textContent = canPurchase ? 'Agregar' : 'Agotado';
      if (paymentWrap) paymentWrap.style.display = canPurchase ? '' : 'none';
    }

    function setVariantMessage(message) {
      if (!variantFeedback) return;
      if (!message) {
        variantFeedback.setAttribute('hidden', '');
        variantFeedback.textContent = '';
        return;
      }
      variantFeedback.textContent = message;
      variantFeedback.removeAttribute('hidden');
    }

    function refreshSticky() {
      var selectedOption = getSelectedOption(select);
      var selectedPrice = selectedOption ? selectedOption.getAttribute('data-price') : '';
      var selectedTitle = selectedOption ? selectedOption.getAttribute('data-title') : '';
      var variantAvailable = !!(selectedOption && !selectedOption.disabled);
      var canPurchase = !!(productAvailable && variantAvailable);

      if (stickyPrice && selectedPrice) stickyPrice.textContent = selectedPrice;

      if (stickyVariant) {
        var shouldShowVariant = !!(select && select.options && select.options.length > 1);
        var variantText =
          selectedTitle && selectedTitle !== 'Default Title' ? selectedTitle : '';
        stickyVariant.textContent = shouldShowVariant ? variantText : '';
        stickyVariant.style.display = stickyVariant.textContent ? '' : 'none';
      }

	      setPurchaseState(canPurchase);
	      if (!productAvailable) {
	        setVariantMessage('');
	      } else if (selectedOption && selectedOption.disabled) {
	        setVariantMessage('Esta opción está agotada. Elige otra variante.');
	      } else {
	        setVariantMessage('');
	      }

      if (!canPurchase) {
        stickyButton.textContent = 'Agotado';
        stickyButton.setAttribute('disabled', '');
        return;
      }

      stickyButton.textContent = 'Agregar';
      stickyButton.removeAttribute('disabled');
    }

    refreshSticky();

    if (select) select.addEventListener('change', refreshSticky);
    if (quantity) {
      quantity.addEventListener('change', function () {
        var nextValue = parseInt(quantity.value || '1', 10);
        if (!Number.isFinite(nextValue) || nextValue < 1) quantity.value = '1';
      });
    }

    stickyButton.addEventListener('click', function () {
      if (!productAvailable) return;

      var selectedOption = getSelectedOption(select);
      if (select && (!select.value || (selectedOption && selectedOption.disabled))) {
        select.classList.add('is-highlight');
        try {
          select.scrollIntoView({ behavior: scrollBehavior(), block: 'center' });
        } catch (e) {}
        select.focus();
        window.setTimeout(function () {
          select.classList.remove('is-highlight');
        }, 1200);
        return;
      }

      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(addToCartButton);
      } else {
        addToCartButton.click();
      }
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          setStickyHidden(!!(entry && entry.isIntersecting));
        },
        { threshold: 0.15 }
      );
      observer.observe(addToCartButton);
    }
  }

  function initHeroBrand(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var heroes = scope.querySelectorAll('[data-hero-brand]');
    if (!heroes || !heroes.length) return;

    Array.prototype.forEach.call(heroes, function (hero) {
      if (!hero || hero.dataset.initialized === 'true') return;
      hero.dataset.initialized = 'true';

      var slides = Array.prototype.slice.call(hero.querySelectorAll('.hero-brand__slides > [data-hero-slide]'));
      var dotsContainer = hero.querySelector('[data-hero-dots]');
      var prev = hero.querySelector('[data-hero-prev]');
      var next = hero.querySelector('[data-hero-next]');
      if (!slides.length) return;

      var autoplayMs = 7000;
      var current = 0;
      var timer;
      var allowAutoplay = !prefersReducedMotion();
      var isPressPausing = false;

      if (dotsContainer) {
        dotsContainer.innerHTML = '';
        slides.forEach(function (_, idx) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'hero-brand__dot' + (idx === 0 ? ' is-active' : '');
          btn.setAttribute('aria-label', 'Slide ' + String(idx + 1));
          btn.setAttribute('data-hero-dot', String(idx));
          dotsContainer.appendChild(btn);
        });
      }
      var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-dot]'));

      function setActive(index) {
        current = (index + slides.length) % slides.length;

        // Remove is-active from all slides first
        slides.forEach(function (slide) {
          slide.classList.remove('is-active');
        });

        // Small delay to ensure CSS transitions trigger properly
        setTimeout(function() {
          slides.forEach(function (slide, idx) {
            var isActive = idx === current;
            if (isActive) {
              slide.classList.add('is-active');
            }
            slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          });
        }, 20);

        dots.forEach(function (dot, idx) {
          dot.classList.toggle('is-active', idx === current);
        });
      }

      function goNext() {
        setActive(current + 1);
      }
      function goPrev() {
        setActive(current - 1);
      }

      function start() {
        clearInterval(timer);
        if (!allowAutoplay || slides.length < 2) return;
        timer = setInterval(goNext, autoplayMs);
      }
      function stop() {
        clearInterval(timer);
      }

      if (prev) {
        prev.addEventListener('click', function () {
          stop();
          goPrev();
          start();
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          stop();
          goNext();
          start();
        });
      }
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var idx = Number(dot.getAttribute('data-hero-dot'));
          stop();
          setActive(idx);
          start();
        });
      });

      var touchStartX = 0;
      var touchStartY = 0;
      var hasTouch = false;

      hero.addEventListener(
        'touchstart',
        function (event) {
          if (!event.touches || event.touches.length !== 1) return;
          touchStartX = event.touches[0].clientX;
          touchStartY = event.touches[0].clientY;
          hasTouch = true;
        },
        { passive: true }
      );

      hero.addEventListener(
        'touchend',
        function (event) {
          if (!hasTouch || !event.changedTouches || !event.changedTouches[0]) return;
          var dx = event.changedTouches[0].clientX - touchStartX;
          var dy = event.changedTouches[0].clientY - touchStartY;
          hasTouch = false;
          if (Math.abs(dx) < 50 || Math.abs(dx) <= Math.abs(dy) * 1.1) return;
          stop();
          if (dx < 0) {
            goNext();
          } else {
            goPrev();
          }
          start();
        },
        { passive: true }
      );

      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', start);

      // Pause while pressing on the active slide; resume on release
      function maybePause(event) {
        if (event.target.closest('[data-hero-prev],[data-hero-next],[data-hero-dot]')) return;
        var slide = event.target.closest('[data-hero-slide]');
        if (slide && slide.classList.contains('is-active')) {
          isPressPausing = true;
          stop();
        }
      }
      function maybeResume() {
        if (!isPressPausing) return;
        isPressPausing = false;
        start();
      }
      hero.addEventListener('mousedown', maybePause);
      hero.addEventListener('mouseup', maybeResume);
      hero.addEventListener(
        'touchstart',
        function (e) {
          maybePause(e);
        },
        { passive: true }
      );
      hero.addEventListener(
        'touchend',
        function () {
          maybeResume();
        },
        { passive: true }
      );

      setActive(0);
      start();
    });
  }

  function initCustomerReviews(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = scope.querySelectorAll('.customer-reviews');
    if (!sections || !sections.length) return;

    Array.prototype.forEach.call(sections, function (section) {
      if (!section || section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      var track = section.querySelector('.reviews-track');
      var prevBtn = section.querySelector('.reviews-nav--prev');
      var nextBtn = section.querySelector('.reviews-nav--next');

      if (!track || !prevBtn || !nextBtn) return;

      var scrollAmount = 320;
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -scrollAmount, behavior: scrollBehavior() });
      });
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: scrollAmount, behavior: scrollBehavior() });
      });
    });
  }

  function initCartPage(root) {
    var scope = root && root.querySelector ? root : document;
    var form = scope.querySelector('.cart-form');
    if (!form || form.dataset.initialized === 'true') return;
    form.dataset.initialized = 'true';

    var status = scope.querySelector('[data-cart-status]');
    var subtotal = scope.querySelector('[data-cart-subtotal]');
    var cartItemsWrap = scope.querySelector('[data-cart-items]');
    var checkoutButtons = Array.prototype.slice.call(
      form.querySelectorAll('button[name="checkout"], button[value="checkout"]')
    );
    var updateButton = form.querySelector('button[name="update"]');

    function setStatus(message) {
      if (!status) return;
      status.textContent = message || '';
    }

    function setCheckoutDisabled(disabled) {
      checkoutButtons.forEach(function (btn) {
        if (!btn) return;
        btn.disabled = !!disabled;
      });
    }

    function normalizeQty(raw) {
      var parsed = parseInt(String(raw || '0'), 10);
      if (!Number.isFinite(parsed)) parsed = 0;
      if (parsed < 0) parsed = 0;
      return parsed;
    }

    var cartQueue = Promise.resolve();
    var abortByKey = new Map();
    var busyCount = 0;

    function setBusy(nextBusy) {
      form.classList.toggle('is-busy', !!nextBusy);
      if (updateButton) updateButton.disabled = !!nextBusy;
      setCheckoutDisabled(!!nextBusy);
    }

    function beginBusy() {
      busyCount += 1;
      setBusy(true);
    }

    function endBusy() {
      busyCount = Math.max(0, busyCount - 1);
      if (busyCount === 0) setBusy(false);
    }

    function enqueue(task) {
      var next = cartQueue.then(task, task);
      cartQueue = next.catch(function () {});
      return next;
    }

    function applyCartState(cart) {
      if (!cart) return;

      if (subtotal && typeof cart.total_price === 'number') {
        subtotal.textContent = formatMoney(cart.total_price);
      }

      var counts = document.querySelectorAll('[data-cart-count]');
      Array.prototype.forEach.call(counts, function (el) {
        if (!el) return;
        el.textContent = String(cart.item_count || 0);
      });

      if (cartItemsWrap && cart.items && cart.items.length === 0) {
        window.location.reload();
      }
    }

    function updateLineFromCart(inputEl, cart) {
      if (!inputEl || !cart || !cart.items) return;
      var itemKey = inputEl.getAttribute('data-cart-item-key');
      if (!itemKey) return;

      var cartItem = null;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i] && cart.items[i].key === itemKey) {
          cartItem = cart.items[i];
          break;
        }
      }

      var itemRoot = inputEl.closest ? inputEl.closest('.cart-item') : null;
      if (!itemRoot) return;

      if (!cartItem) {
        itemRoot.remove();
        return;
      }

      var priceCurrent = itemRoot.querySelector('.price-current');
      if (priceCurrent) priceCurrent.textContent = formatMoney(cartItem.final_line_price);

      var priceCompare = itemRoot.querySelector('.price-compare');
      if (priceCompare) {
        if (cartItem.original_line_price && cartItem.original_line_price !== cartItem.final_line_price) {
          priceCompare.textContent = formatMoney(cartItem.original_line_price);
          priceCompare.style.display = '';
        } else {
          priceCompare.textContent = '';
          priceCompare.style.display = 'none';
        }
      }
    }

    function sendChange(inputEl, nextQty) {
      var key = inputEl.getAttribute('data-cart-item-key');
      if (!key) return Promise.resolve();

      var controller = abortByKey.get(key);
      if (controller) controller.abort();
      controller = new AbortController();
      abortByKey.set(key, controller);

      beginBusy();
      setStatus('Actualizando carrito…');

      return fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ id: key, quantity: nextQty }),
        signal: controller.signal
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().catch(function () {}).then(function (err) {
              throw err || new Error('Cart change failed');
            });
          }
          return response.json();
        })
        .then(function (cart) {
          inputEl.dataset.lastCommitted = String(nextQty);
          updateLineFromCart(inputEl, cart);
          applyCartState(cart);
          setStatus('Carrito actualizado.');
          window.setTimeout(function () {
            setStatus('');
          }, 1200);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          var lastCommitted = normalizeQty(inputEl.dataset.lastCommitted || inputEl.value);
          inputEl.value = String(lastCommitted);
          setStatus('No se pudo actualizar. Intenta de nuevo.');
        })
        .finally(function () {
          endBusy();
        });
    }

    function ensureCommitted(inputEl, opts) {
      opts = opts || {};
      var nextQty = normalizeQty(inputEl.value);
      inputEl.value = String(nextQty);

      var lastCommitted = normalizeQty(inputEl.dataset.lastCommitted || inputEl.defaultValue);
      if (nextQty === lastCommitted) return Promise.resolve();

      inputEl.classList.add('is-updating');
      return enqueue(function () {
        return sendChange(inputEl, nextQty).finally(function () {
          inputEl.classList.remove('is-updating');
        });
      });
    }

    function initQtyInput(inputEl) {
      if (!inputEl || inputEl.dataset.qtyInit === 'true') return;
      inputEl.dataset.qtyInit = 'true';
      inputEl.dataset.lastCommitted = String(normalizeQty(inputEl.value));

      var timer = null;
      function schedule() {
        clearTimeout(timer);
        timer = window.setTimeout(function () {
          ensureCommitted(inputEl);
        }, 500);
      }

      inputEl.addEventListener('input', schedule);
      inputEl.addEventListener('change', schedule);
      inputEl.addEventListener('blur', function () {
        clearTimeout(timer);
        ensureCommitted(inputEl, { immediate: true });
      });

      var wrapper = inputEl.closest ? inputEl.closest('[data-qty-control]') : null;
      if (wrapper) {
        var minus = wrapper.querySelector('[data-qty-minus]');
        var plus = wrapper.querySelector('[data-qty-plus]');

        if (minus) {
          minus.addEventListener('click', function () {
            var next = normalizeQty(inputEl.value) - 1;
            inputEl.value = String(Math.max(0, next));
            inputEl.dispatchEvent(new Event('input', { bubbles: true }));
          });
        }

        if (plus) {
          plus.addEventListener('click', function () {
            var next = normalizeQty(inputEl.value) + 1;
            inputEl.value = String(next);
            inputEl.dispatchEvent(new Event('input', { bubbles: true }));
          });
        }
      }
    }

    var qtyInputs = Array.prototype.slice.call(form.querySelectorAll('input[name="updates[]"]'));
    qtyInputs.forEach(initQtyInput);

    var lastSubmitter = null;
    checkoutButtons.forEach(function (btn) {
      if (!btn) return;
      btn.addEventListener('click', function () {
        lastSubmitter = btn;
      });
    });

    form.addEventListener('submit', function (event) {
      if (form.dataset.submitting === 'true') return;

      var submitter = event.submitter || lastSubmitter;
      var isCheckout = !!(submitter && submitter.getAttribute && submitter.getAttribute('name') === 'checkout');
      if (!isCheckout) return;

      var dirtyInputs = qtyInputs.filter(function (inputEl) {
        var nextQty = normalizeQty(inputEl.value);
        var lastCommitted = normalizeQty(inputEl.dataset.lastCommitted || inputEl.value);
        return nextQty !== lastCommitted;
      });

      if (!dirtyInputs.length && busyCount === 0) return;

      event.preventDefault();
      setStatus('Actualizando antes de pagar…');

      Promise.all(dirtyInputs.map(function (inputEl) { return ensureCommitted(inputEl, { immediate: true }); }))
        .then(function () {
          form.dataset.submitting = 'true';
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit(submitter);
          } else {
            form.submit();
          }
        })
        .catch(function () {
          setStatus('No se pudo actualizar. Revisa las cantidades e intenta de nuevo.');
        });
    });
  }

  function initNotifyModal(root) {
    var scope = root && root.querySelector ? root : document;
    var modal = scope.querySelector('[data-notify-modal]');
    if (!modal || modal.dataset.initialized === 'true') return;
    modal.dataset.initialized = 'true';

    var openers = scope.querySelectorAll('[data-notify-open]');
    var closeButtons = modal.querySelectorAll('[data-notify-close]');
    var dialog = modal.querySelector('.notify-modal__dialog');
    var form = modal.querySelector('form');
    var submitButton = modal.querySelector('[data-notify-submit]');
    var lastFocused = null;
    var isOpen = false;

    function openModal(trigger) {
      if (isOpen) return;
      isOpen = true;
      lastFocused = trigger || document.activeElement;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      setPageScrollLocked(true);
      var focusTarget = dialog || modal;
      window.setTimeout(function () {
        try {
          focusTarget.focus();
        } catch (e) {}
      }, 0);
    }

    function closeModal() {
      if (!isOpen) return;
      isOpen = false;
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      setPageScrollLocked(false);
      if (lastFocused && typeof lastFocused.focus === 'function') {
        try {
          lastFocused.focus();
        } catch (e) {}
      }
    }

    Array.prototype.forEach.call(openers, function (btn) {
      btn.addEventListener('click', function () {
        openModal(btn);
      });
    });

    Array.prototype.forEach.call(closeButtons, function (btn) {
      btn.addEventListener('click', function () {
        closeModal();
      });
    });

    window.addEventListener('pagehide', closeModal);
    window.addEventListener('pageshow', closeModal);

    if (form && submitButton) {
      form.addEventListener('submit', function (event) {
        submitButton.disabled = true;
        submitButton.classList.add('is-loading');
        modal.classList.add('is-busy');

        // Allow a paint frame so the progress bar is visible before submit
        if (!form.dataset.notifySubmitting) {
          event.preventDefault();
          form.dataset.notifySubmitting = 'true';
          window.setTimeout(function () {
            form.submit();
          }, 120);
        }
      });
    }

    if (modal.querySelector('.notify-modal__success')) {
      openModal();
    }

    document.addEventListener('keydown', function (event) {
      if (!isOpen) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal();
      }
    });
  }

  function initLaunchCountdowns(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll('[data-launch-countdown]');
    if (!nodes || !nodes.length) return;

    Array.prototype.forEach.call(nodes, function (node) {
      if (!node || node.dataset.initialized === 'true') return;
      node.dataset.initialized = 'true';

      var tsRaw = node.getAttribute('data-launch-ts');
      var targetTs = parseInt(tsRaw || '', 10);
      if (!Number.isFinite(targetTs) || targetTs <= 0) {
        node.setAttribute('hidden', '');
        return;
      }

      var card = node.closest ? node.closest('.collection-card, .catalog-index__card') : null;
      var daysEl = node.querySelector('[data-launch-unit="days"]');
      var hoursEl = node.querySelector('[data-launch-unit="hours"]');
      var minutesEl = node.querySelector('[data-launch-unit="minutes"]');
      var secondsEl = node.querySelector('[data-launch-unit="seconds"]');

      function pad2(value) {
        return String(value).padStart(2, '0');
      }

      var timer = null;
      function render() {
        var diffMs = targetTs * 1000 - Date.now();
        if (diffMs <= 0) {
          node.setAttribute('hidden', '');
          if (card) card.classList.remove('is-coming-soon');
          clearInterval(timer);
          return;
        }

        var totalSeconds = Math.floor(diffMs / 1000);
        var days = Math.floor(totalSeconds / 86400);
        var hours = Math.floor((totalSeconds % 86400) / 3600);
        var minutes = Math.floor((totalSeconds % 3600) / 60);
        var seconds = totalSeconds % 60;

        if (daysEl) daysEl.textContent = String(days);
        if (hoursEl) hoursEl.textContent = pad2(hours);
        if (minutesEl) minutesEl.textContent = pad2(minutes);
        if (secondsEl) secondsEl.textContent = pad2(seconds);
      }

      render();
      timer = setInterval(render, 1000);
    });
  }

  function initAboutForestAnimations(root) {
    if (prefersReducedMotion()) return;

    var scope = root && root.querySelectorAll ? root : document;
    var sections = scope.querySelectorAll('[data-about-forest]');
    if (!sections || !sections.length) return;

    Array.prototype.forEach.call(sections, function (forest) {
      if (!forest || forest.dataset.animInitialized === 'true') return;
      forest.dataset.animInitialized = 'true';
      forest.classList.add('has-forest-animations');

      var revealables = [];

      function queue(el, delay, duration) {
        if (!el) return;
        el.style.setProperty('--forest-delay', (delay || 0) + 'ms');
        if (duration) {
          el.style.setProperty('--forest-duration', duration + 'ms');
        }
        revealables.push(el);
      }

      var contentBlocks = forest.querySelectorAll('.about-forest__content');
      Array.prototype.forEach.call(contentBlocks, function (block, idx) {
        queue(block, 20 + idx * 70, 340);
      });

      var medias = forest.querySelectorAll('.about-forest__media');
      Array.prototype.forEach.call(medias, function (media, idx) {
        queue(media, idx * 40, 280);
      });

      var guardians = forest.querySelectorAll('.about-forest__guardian');
      Array.prototype.forEach.call(guardians, function (card, idx) {
        queue(card, 40 + idx * 55, 300);
      });

      var listItems = forest.querySelectorAll('.about-forest__list [data-forest-reveal]');
      Array.prototype.forEach.call(listItems, function (item, idx) {
        queue(item, 70 + idx * 45, 280);
      });

      if (!('IntersectionObserver' in window)) {
        revealables.forEach(function (el) {
          el.classList.add('is-visible');
        });
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var rectTop = entry.boundingClientRect ? entry.boundingClientRect.top : 0;
              if (rectTop < 48) {
                entry.target.style.setProperty('--forest-delay', '0ms');
              }
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px 16% 0px' }
      );

      revealables.forEach(function (el) {
        observer.observe(el);
      });
    });
  }

  function initStickyHeader(root) {
    var scope = root && root.querySelector ? root : document;
    var header = scope.querySelector('.playful-header');
    if (!header) return;

    var isTouchCollectionPage = false;
    try {
      isTouchCollectionPage =
        document.body &&
        document.body.classList &&
        document.body.classList.contains('template-collection') &&
        ((window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches) ||
          (window.matchMedia && window.matchMedia('(max-width: 820px)').matches));
    } catch (e) {}

    if (isTouchCollectionPage) {
      header.classList.remove('is-compact');
      document.documentElement.style.setProperty('--header-offset', '0px');
      document.documentElement.style.scrollBehavior = 'auto';
      return;
    }

    var resizeTimer = null;
    var ticking = false;
    var isCompact = header.classList.contains('is-compact');
    function syncHeaderOffset() {
      var next = header.offsetHeight || 0;
      document.documentElement.style.setProperty('--header-offset', next + 'px');
    }

    syncHeaderOffset();

    function updateCompact() {
      ticking = false;
      var shouldCompact = window.scrollY > 48;
      if (shouldCompact === isCompact) return;
      isCompact = shouldCompact;
      if (shouldCompact) {
        header.classList.add('is-compact');
      } else {
        header.classList.remove('is-compact');
      }
      syncHeaderOffset();
    }

    updateCompact();

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateCompact);
      },
      { passive: true }
    );

    window.addEventListener('resize', function () {
      if (resizeTimer) window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(syncHeaderOffset, 100);
    });
  }

  function initAll(root) {
    var scope = root && root.querySelector ? root : document;

    if (scope.querySelector('[data-product-gallery]')) initProductGalleries(root);
    if (scope.querySelector('[data-sticky-atc]')) initPdpStickyAtc();
    if (scope.querySelector('[data-cart-modal]')) initCartModal(root);
    if (scope.querySelector('[data-cart-count]')) initCartCount(root);
    if (scope.querySelector('.collection-card')) initCollectionCardLinks(root);
    if (scope.querySelector('.cart-form')) initCartPage(root);
    if (scope.querySelector('.playful-header')) initStickyHeader(root);
    if (scope.querySelector('[data-launch-countdown]')) initLaunchCountdowns(root);
    if (scope.querySelector('[data-about-forest]')) initAboutForestAnimations(root);
    if (scope.querySelector('[data-hero-brand]')) initHeroBrand(root);
    if (scope.querySelector('.customer-reviews') || scope.querySelector('.jdgm-carousel')) initCustomerReviews(root);
    if (scope.querySelector('[data-qr-code]')) initGiftCardQr(root);
    if (scope.querySelector('[data-notify-modal]')) initNotifyModal(root);
  }

  onReady(function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event && event.target ? event.target : document);
  });
})();
